import type { ActivationMotionConfig } from './activationViewModel.types'

export const resolveActivationMotionConfig = (
  prefersReducedMotion: boolean,
): ActivationMotionConfig => ({
  pageMotion: { opacity: 1, y: 0 },
  pageInitialMotion: prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: 10 },
  cardInitialMotion: prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: 12 },
  stateTransition: {
    duration: prefersReducedMotion ? 0.14 : 0.22,
    ease: [0.22, 1, 0.36, 1],
  },
})
